import { useState, useRef, useEffect } from "react"
import { Formik, Field, Form } from "formik"
import {
  InputGroup,
  FieldWrappers,
  Label,
  SubmitBtn,
  Wrapper,
  ActionSection,
  ScrollableContent,
  SideCancelBtn,
  CardWrapper,
  SelectionCard,
  Note,
} from "../Styles/InputStyles"
import { toast } from "react-toastify"
import { MdClose } from "react-icons/md"
import tw from "tailwind-styled-components"
import "react-dropdown/style.css"
import { Checkbox, FormControlLabel } from "@mui/material"
import { gracePeriod } from "../../helpers"

const EditFineModal = ({
  selectedData,
  editFineDetailsLoading,
  editFineDetailsMutate,
  handleClose
}) => {

  const formikRef = useRef(null)
  const [height, setHeight] = useState(window.innerHeight)

  const fine = [
    { label: "Yes", value: 1 },
    { label: "No", value: 2 },
  ];

  const fineType = [
    { label: "One Time", value: 1 },
    { label: "Daily", value: 2 },
  ];

  useEffect(() => {
    const handleResize = () => {
      setHeight(window.innerHeight)
    }
    window.addEventListener("resize", handleResize)
    handleResize()
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  const initialValues = {
    gracePeriod: selectedData?.gracePeriod || "",
    fine: selectedData?.fine ? 1 : 2 || "",
    fineAmount: selectedData?.fine || "",
    fineType: "",
    updateTenant: false,
  };


  const handleSubmit = (values) => {
    const amountDepositRegex = /^\d{1,4}$/;
    const maxAmountDeposit = 10000;

    if (!values.gracePeriod || !values.fine) {
      toast.error("All fields are required");
      return;
    }


    if (values.fine === 1) {
      if (!values.fineAmount) {
        toast.error("Fine amount is required");
        return;
      }
      if (values.fineAmount <= 0) {
        toast.error("Fine amount must be positive");
        return;
      }
      if (!amountDepositRegex.test(values.fineAmount) || parseInt(values.fineAmount) > maxAmountDeposit) {
        toast.error("Amount deposit must be between 1 and 10,000 and contain only numbers");
        return;
      }
      if (!values.fineType) {
        toast.error("Fine type is required");
        return;
      }
    }

    editFineDetailsMutate({

      propId: selectedData?.id,
      gracePeriod: values.gracePeriod,
      fine: Number(values.fineAmount) || 0,
      fineType: values.fineType || 0,
      updateTenants: values.updateTenant ? 1 : 0,
    });
  }




  return (
    <Container style={{ height: `${height}px`, overflow: "auto", WebkitOverflowScrolling: "touch" }}>
      <Header>
        <h1 className="text-lg font-medium text-white">Edit Fine Details</h1>
        <button onClick={handleClose}>
          <MdClose color="white" size={24} />
        </button>
      </Header>
      <div className="custom-scrollbar flex h-full flex-col justify-between px-6">

        <Formik innerRef={formikRef} initialValues={initialValues} onSubmit={handleSubmit}>
          {({ values, setFieldValue, handleChange, handleBlur, errors, touched }) => (
            <Form>
              <ScrollableContent className="max-h-[calc(100vh-140px)]">
                <Wrapper>
                  <InputGroup>
                    <Label>Grace Period *</Label>
                    <CardWrapper>
                      {gracePeriod.map((mode) => (
                        <SelectionCard
                          key={mode.value}
                          type="button"
                          onClick={(e) => {
                            e.preventDefault();
                            setFieldValue("gracePeriod", mode.value, false);

                          }}
                          className={values.gracePeriod === mode.value ? "bg-[#0078BD] text-white"
                            : "bg-gray-100 text-gray-800"}
                        >
                          <span className="text-sm">{mode.label}</span>
                        </SelectionCard>
                      ))}
                    </CardWrapper>
                  </InputGroup>

                  <InputGroup>
                    <Label>Fine *</Label>
                    <CardWrapper>
                      {fine.map((mode) => (
                        <SelectionCard
                          key={mode.value}
                          type="button"
                          onClick={(e) => {
                            e.preventDefault();
                            setFieldValue("fine", mode.value, false);

                          }}
                          className={values.fine === mode.value ? "bg-[#0078BD] text-white"
                            : "bg-gray-100 text-gray-800"}
                        >
                          <span className="text-sm">{mode.label}</span>
                        </SelectionCard>
                      ))}
                    </CardWrapper>
                  </InputGroup>
                  {values.fine === 1 && (
                    <>
                      <InputGroup>
                        <Label htmlFor="fineAmount">Fine Amount *</Label>
                        <FieldWrappers>
                          <Field
                            type="number"
                            name="fineAmount"
                            id="fineAmount"
                            value={values.fineAmount}
                            onChange={(e) => setFieldValue("fineAmount", e.target.value)}
                            required
                          />
                        </FieldWrappers>
                      </InputGroup>
                      <InputGroup>
                        <Label>Fine Type *</Label>
                        <CardWrapper>
                          {fineType.map((mode) => (
                            <SelectionCard
                              key={mode.value}
                              type="button"
                              onClick={(e) => {
                                e.preventDefault();
                                setFieldValue("fineType", mode.value);

                              }}
                              className={values.fineType === mode.value ? "bg-[#0078BD] text-white"
                                : "bg-gray-100 text-gray-800"}
                            >
                              <span className="text-sm">{mode.label}</span>
                            </SelectionCard>
                          ))}
                        </CardWrapper>
                      </InputGroup>
                    </>
                  )}
                  <InputGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={values.updateTenant}
                          onChange={(e) => setFieldValue("updateTenant", e.target.checked)}
                          color="primary"
                        />
                      }
                      label={
                        <span className="text-sm text-gray-500 font-normal">
                          Update for all tenant
                        </span>
                      }
                    />
                  </InputGroup>
                </Wrapper>
              </ScrollableContent>
              <ActionSection>
                <SideCancelBtn type="button" onClick={handleClose}>
                  Cancel
                </SideCancelBtn>
                <SubmitBtn type="submit" disabled={editFineDetailsLoading}>
                  {editFineDetailsLoading ? "Submitting..." : "Submit"}
                </SubmitBtn>
              </ActionSection>

            </Form>
          )}
        </Formik>
      </div>
    </Container>
  )
}

const Container = tw.div`bg-white w-full h-full flex flex-col relative`
const Header = tw.div`flex items-center justify-between bg-primary-color py-4 px-4`
const Textarea = tw.textarea`min-h-10 max-h-40 border border-gray-300 rounded pl-2 py-2 focus:ring-1 focus:ring-sky-600  focus:border-sky-600 focus:outline-none duration-200 w-full h-20 resize-y break-words overflow-hidden`
const PaymentModeWrapper = tw.div`grid grid-cols-4 gap-2 my-1.5`
const PaymentModeCard = tw.button`flex flex-col items-center justify-center p-2 border rounded-lg shadow-sm cursor-pointer`
const Vendor = tw.button`text-blue-500 text-sm flex hover:underline`
const FieldWrapper = tw.div`w-full`
const ExpenseDateRepetitionBtn = tw.button`
  flex items-center justify-center flex-col
  px-4 py-2
  text-sm font-medium text-gray-600
  bg-white 
  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500
  disabled:opacity-50
`

export default EditFineModal